import React, { FC, useEffect, useState } from 'react'
import { injectIntl } from 'react-intl'
import { withStyles, WithStyles } from '@zn-material-ui'
import { useHistory } from 'react-router-dom'
import { initI18n } from '@common/i18n'
import styles from './styles'
import downImg from '@images/intl/down@2x.png'
import upImg from '@images/intl/up2@2x.png'
import IntlCommon from '@stores/IntlCommon'
import moment from 'moment'
import 'moment/locale/zh-cn'
import 'moment/locale/zh-tw'
import 'moment/locale/en-ca'
import 'moment/locale/ms'
import 'moment/locale/th'
import 'moment/locale/ja'
import 'moment/locale/ko'
type IProps1 = WithStyles<typeof styles>

interface IState {
  lang: string
  show: boolean
  showTxt: string
}

interface IProps {
  containerStyle?: any
  intl: any
}

const languagelist = [
  { lang: '简体中文', value: 'zh' },
  { lang: '繁体中文', value: 'tw' },
  { lang: 'English', value: 'en' },
  // { lang: '日本語', value: 'ja' },
  // { lang: '한국어', value: 'ko' },
  // { lang: 'Malay', value: 'ms' },
  // { lang: 'ภาษาไทย', value: 'th' },
]

const SwitchLanguage = (props: IProps & IProps1) => {
  const [show, setShow] = useState(false)
  const [showTxt, setshowTxt] = useState('简体中文')
  const history = useHistory()
  const boxOnClick = () => {
    setShow(!show)
  }

  const refresh = () => {
    history.push('/' + new Date().getTime())
    setTimeout(() => {
      history.go(-1)
    }, 20)
  }

  const changeLanguage = async (val: any, lang: any) => {
    setshowTxt(lang)
    setShow(!show)
    moment.locale(IntlCommon.MomentMes[val])
    IntlCommon.setBrowserLanguage(val)
    localStorage.setItem('browserLanguage', val)
    document.documentElement.setAttribute('lang',val)
    // 切换网页名
    if (val === 'zh') {
      document.title = '学习平台'
    }  else if (val === 'tw') {
      document.title = '學習平臺'
    } else if (val === 'en') {
      document.title = 'Learning platform'
    }
    // 加载语言
    if (window.location.href.includes('localhost')) {
      await initI18n('/lang')
    } else {
      await initI18n(process.env.PUBLIC_URL + '/lang')
    }
    refresh()
  }

  useEffect(() => {
    const data = languagelist.filter(
      ele => ele.value === IntlCommon.browserLanguage
    )
    setshowTxt(data[0].lang)
  }, [])

  useEffect(() => {
    IntlCommon.setIntlFun(props.intl)
  }, [IntlCommon.browserLanguage])

  const { classes, containerStyle } = props
  return (
    <div className={classes.switchLanguage}>
      <div className={classes.box} onClick={boxOnClick}>
        {showTxt}
        <img src={show ? upImg : downImg} className={classes.imgIcon} />
      </div>
      {show ? (
        <div className={classes.switchBox} style={containerStyle}>
          {languagelist.map(item => (
            <p
              key={item.value}
              className={showTxt === item.lang ? classes.selected : ''}
              onClick={changeLanguage.bind(this, item.value, item.lang)}
            >
              {item.lang}
            </p>
          ))}
        </div>
      ) : (
        ''
      )}
    </div>
  )
}
export default injectIntl(withStyles(styles)(SwitchLanguage))
